import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  runTransaction,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { v4 as uuidv4 } from "uuid";

export const subscribeToRawInventory = (callback) => {
  const unsubscribe = onSnapshot(
    collection(db, "raw-inventory"),
    (snapshot) => {
      const productsArray = snapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));

      callback({ products: productsArray, error: null });
    },
    (error) => {
      console.log("Error getting documents: ", error);
      callback({ products: [], error: error.message });
    }
  );

  return unsubscribe; // Return the unsubscribe function to stop listening
};

export const subscribeToRepairedInventory = (callback) => {
  const unsubscribe = onSnapshot(
    collection(db, "repaired-inventory"),
    (snapshot) => {
      const productsArray = snapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));

      callback({ products: productsArray, error: null });
    },
    (error) => {
      console.log("Error getting documents: ", error);
      callback({ products: [], error: error.message });
    }
  );

  return unsubscribe; // Return the unsubscribe function to stop listening
};
export const directAddMainInventory = async ( formData) => {

  try {
    await runTransaction(db, async (transaction) => {


      let uniqueBarcode;
      const generateUniqueBarcode = async () => {
        while (true) {
          const randomNumber = Math.floor(100000000 + Math.random() * 900000000);
          const candidateBarcode = `IMG${randomNumber}`;
          const existingDocRef = doc(db, "all-products", candidateBarcode);
          const existingDocSnap = await transaction.get(existingDocRef);

          if (!existingDocSnap.exists()) {
            return candidateBarcode; 
          }
        }
      };

      uniqueBarcode = await generateUniqueBarcode();

      // Prepare the new inventory data
      const addedTimestamp = Timestamp.now();
      const mainDocRef = doc(db, "all-products", uniqueBarcode);
      transaction.set(mainDocRef, {
        ...formData,
        addedOn: addedTimestamp,
        serialNumber: uniqueBarcode,
        status: "inventory",
        history: [
          {
            status: "inventory",
            timestamp: addedTimestamp,
          },
        ],
      });
    });

    return { success: "Item successfully updated." };
  } catch (error) {
    return { error: "Error Adding inventory: " + error.message };
  }
};
export const addMainInventory = async (id, formData) => {
  const repairedDocRef = doc(db, "repaired-inventory", id);

  try {
    await runTransaction(db, async (transaction) => {
      const repairDocSnap = await transaction.get(repairedDocRef);

      if (!repairDocSnap.exists()) {
        throw new Error("No Repairing Item for this ID");
      }

      let uniqueBarcode;
      const generateUniqueBarcode = async () => {
        while (true) {
          const randomNumber = Math.floor(100000000 + Math.random() * 900000000);
          const candidateBarcode = `IMG${randomNumber}`;
          const existingDocRef = doc(db, "all-products", candidateBarcode);
          const existingDocSnap = await transaction.get(existingDocRef);

          if (!existingDocSnap.exists()) {
            return candidateBarcode; 
          }
        }
      };

      uniqueBarcode = await generateUniqueBarcode();

      // Delete the repaired document
      transaction.delete(repairedDocRef);

      // Prepare the new inventory data
      const addedTimestamp = Timestamp.now();
      const mainDocRef = doc(db, "all-products", uniqueBarcode);
      transaction.set(mainDocRef, {
        ...formData,
        addedOn: addedTimestamp,
        serialNumber: uniqueBarcode,
        status: "inventory",
        history: [
          {
            status: "inventory",
            timestamp: addedTimestamp,
          },
        ],
      });
    });

    return { success: "Item successfully updated." };
  } catch (error) {
    return { error: "Error Adding inventory: " + error.message };
  }
};



export const addRepairedInventory = async (id, formData) => {
  const rawDocRef = doc(db, "raw-inventory", id);

  try {
    await runTransaction(db, async (transaction) => {
      const rawDocSnap = await transaction.get(rawDocRef);

      if (!rawDocSnap.exists()) {
        throw new Error("Item not available in your inventory.");
      }

      const rawItem = rawDocSnap.data();

      // Check if there's enough quantity in raw inventory
      if (rawItem.quantity <= 0) {
        transaction.delete(rawDocRef);
        throw new Error("Insufficient quantity in raw inventory.");
      }

      // Calculate the new quantity
      const newQuantity = rawItem.quantity - 1;

      // Update the raw inventory document
      if (newQuantity > 0) {
        // Update the quantity if it's greater than 0
        transaction.update(rawDocRef, {
          quantity: newQuantity,
        });
      } else {
        // Delete the raw inventory document if quantity becomes 0
        transaction.delete(rawDocRef);
      }

      // Add a new document to the repaired inventory collection
      const repairedDocRef = collection(db, "repaired-inventory");
      await addDoc(repairedDocRef, {
        ...formData,
        updatedAt: Timestamp.now(),
      });
    });

    return { success: "Item successfully updated." };
  } catch (error) {
    console.error("Error updating inventory:", error);
    return { error: "Error updating inventory: " + error.message };
  }
};
